import React from 'react';

import XCircle from '@assets/Icons/XCircle';

import styles from './style.module.scss';
type Props = {
  message: string;
  clear: () => void;
};
const ErrorBox: React.FC<Props> = ({ message, clear }) => {
  return message ? (
    <div className={styles.container}>
      <span>{message}</span>
      <div onClick={() => clear()}>
        <XCircle />
      </div>
    </div>
  ) : null;
};

export default ErrorBox;
